import i18n, { userLanguage } from '@i18n/index'
import useConfigStore from '@stores/Config'
import router from './router'
import { createPinia } from 'pinia'
import { AppConf } from '@appTypes/Conf'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import useUserStore from '@stores/userStore'
import useUserDetailsStore from '@stores/userDetailsStore'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import './style.css'

export const pinia = createPinia()
const configStore = useConfigStore(pinia)
const userStore = useUserStore(pinia)
const userDetailsStore = useUserDetailsStore(pinia)
userStore.initStore()
userDetailsStore.initStore()
pinia.use(piniaPluginPersistedstate)

library.add(fas)

const asyncBootstrap = async (conf: AppConf) => {
  try {
    const { createAPI } = await import('@plugins/APIPlugin')
    const { createApp, defineAsyncComponent } = await import('vue')
    const AsyncApp = defineAsyncComponent(() => import('./App.vue'))
    createApp(AsyncApp)
      .use(i18n)
      .use(router)
      .use(pinia)
      .component('fa', FontAwesomeIcon)
      .use(createAPI(conf))
      .mount('#app')
  } catch (e) {
    console.log(e)
    window.location.replace(`login-error-${userLanguage}.html`)
  }
}
if (!configStore.isConfDefined) {
  fetch('config/config.json')
    .then((r) => r.json())
    .then((conf: AppConf) => {
      configStore.setInfoFromConf(conf)
      asyncBootstrap(conf)
    })
    .catch(() => window.location.replace(`login-error-${userLanguage}.html`))
}
